import { Module } from 'vuex';
import { RootState } from '@/store/types';
import { StudentsState } from '@/store/students/types';
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

const Students: Module<StudentsState, RootState> = {
  state: (): StudentsState => ({
    students: [],
    courseHistories: [],
    courseGrades: [],
    pager: {
      current: 1,
      last: 1,
      totalLength: 0,
    },
    conditions: undefined,
    sort: undefined,
  }),
  mutations,
  actions,
  getters,
};

export default Students;
